import { Typography } from "@mui/material";
import styled from "styled-components";
import { theme } from "styles/mui-config";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";

export const StyledCardContent = styled(CardContent)`
  color: ${theme.palette.primary.dark};
  // border-right: 4px solid ${theme.palette.primary.dark};
  padding: 10px !important;
  // margin-top: 20px;
  position: relative;
  & p {
    text-align: center;
    padding-top: 10px;
  }
  &::before {
    content: "";
    position: absolute;
    right: 50%;
    left: 50%;
    top: 0px;
    width: 100px;
    border: 3px solid ${theme.palette.primary.dark};
    border-radius: 1px;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    pointer-events: none;
    transform: translate(50%);
  }
`;

export const StyledContainer = styled(Container)`
  @media (max-width: 900px) {
    padding: 0 !important;
  }
`;

// export const StyledCard = styled(Card)`
//   background-color: ${theme.palette.primary.light} !important;
//   width: 100%;
//   margin-bottom: 10px;
//   position: relative;
// `;
export const StyledCard = styled(Card)`
  background-color: transparent !important;
  width: 100%;
  margin-bottom: 10px;
  position: relative;
  border-radius: 0 !important;
  box-shadow: none !important;
  border-bottom: 2px solid #0000002b;
  // :first-child {
  //   border-top: 2px solid #0000002b;
  //   padding-top: 10px;
  // }
`;

export const StyledTypography = styled(Typography)`
  min-height: 35px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -moz-box-orient: vertical;
  line-height: 27px !important;
  padding-right: 6px;
  margin-bottom: 7px !important;
  & > span {
    color: #535353;
  }
`;

export const StyledNewMessage = styled.div`
  padding: 4px;
  background: ${theme.palette.primary.dark};
  display: inline-block;
  position: absolute;
  bottom: 15px;
  right: 15px;
  color: white;
  border-radius: 4px;
  font-size: 9px;
`;

export const StyledCardActions = styled(CardActions)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 11px !important;
  padding-top: 0 !important;
  padding-left: 0 !important;
  & > p {
    margin: 0;
  }
`;

export const StyledSpan = styled.span`
  padding: 4px;
  background: ${theme.palette.primary.dark};
  display: inline-block;
  border-radius: 100%;
  width: 40px;
  height: 40px;
  color: white;
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledDivIcon = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 15px !important;
  color: ${theme.palette.primary.dark};
  background: #03baea17;
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;

export const StyledDivtext = styled.div`
  display: inline-flex;
  flex-direction: column;
  padding-right: 10px;
  font-size: 15px;
  & h4 {
    margin: 0;
    color: ${theme.palette.primary.dark};
    margin-bottom: 3px;
  }
  & p {
    margin: 0;
    color: #939393;
  }
  & p > a {
    margin: 0;
    color: #939393;
  }
`;

export const StyledPaper = styled(Paper)`
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important;
  // margin-bottom: 10px;
  & div > div {
    border-radius: 15px !important;
  }
`;
